
const nextStatus = (oldStatus) => {
    let newStatus;
  
    switch (oldStatus) {
      case "placed":
      case "scheduled":
        newStatus = 'confirmed';
        break;
      case "confirmed":
        newStatus = 'allocated';
        break;
      case "allocated":
        newStatus = 'pickingUp';
        break;
      case "pickingUp":
        newStatus = 'picked';
        break;
      case "picked":
        newStatus = 'droppingOff';
        break;
      case "droppingOff":
      case "onHold":
        newStatus = 'delivered';
        break;
      default:
    }
    return newStatus
};



const isStatusAtEndState = (status) => {
  let value = false;
  switch (status) {
      case 'cancelled':
      case 'rejected':
      case 'courierNotFound':
      case 'delivered':
      case 'returned':
      case 'disposed':
          value = true
          break;
  }
  return value
};

const isStatusAvailableForFulfillment = (status) => {
  let value = false;
  switch (status) {
      case 'confirmed':
      case 'allocated':
      case 'pickingUp':
          value = true
          break;
  }
  return value
};

const isStatusCannotCancel = (status) => {
  let value = false;
  switch (status) {
      case 'cancelled':
      case 'onHold':
      case 'droppingOff':
      case 'picked':
      case 'returned':
      case 'rejected':
      case 'courierNotFound':
      case 'disposed':
      case 'returnInTransit':
      case 'returned':
      case 'delivered':
          value = true
          break;
  }
  return value
}

const isStatusAtConfirmedByAdmin = (status) => {
  let value = false;
  if (!(status === 'placed' || status === 'scheduled')) {
      value = true
  }
  return value
}

const isStatusCanBeNext = (status) => {
  let value = false;
  switch (status) {
      case 'confirmed':
      case 'allocated':
      case 'pickingUp':
      case 'picked':
      case 'droppingOff':
      case 'onHold':
          value = true
          break;
  }
  return value
}

const isGroupStatus = (status) => {
  let value = false;
  switch (status) {
      case 'preActive':
      case 'active':
      case 'notActive':
      case 'pending':
          value = true
          break;
  }
  return value
};

const isStatusNeedCancelCourier = (status) => {
  let value = true;
  switch (status) {
      case 'placed':
      case 'pending':
          value = false
          break;
  }
  return value
}

export default {
    nextStatus,
    isGroupStatus,
    isStatusAtEndState,
    isStatusCannotCancel,
    isStatusAtConfirmedByAdmin,
    isStatusAvailableForFulfillment,
    isStatusNeedCancelCourier,
    isStatusCanBeNext
}